import { render, staticRenderFns } from "./DialogChangeTransferStatusCompanyAdminLimited.vue?vue&type=template&id=fcdab89a&"
import script from "./DialogChangeTransferStatusCompanyAdminLimited.vue?vue&type=script&lang=js&"
export * from "./DialogChangeTransferStatusCompanyAdminLimited.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangeTransferStatusCompanyAdminLimited.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcdab89a')) {
      api.createRecord('fcdab89a', component.options)
    } else {
      api.reload('fcdab89a', component.options)
    }
    module.hot.accept("./DialogChangeTransferStatusCompanyAdminLimited.vue?vue&type=template&id=fcdab89a&", function () {
      api.rerender('fcdab89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogChangeTransferStatusCompanyAdminLimited.vue"
export default component.exports